import { jwtDecode } from 'jwt-decode';

export const isTokenExpired = (token: string) => {
  if (!token) {
    return true; // No token, so consider it expired or invalid
  }
  try {
    var decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000; // Current time in seconds
    return (decodedToken.exp as number) < currentTime;


  } catch (error) {
    // Handle invalid token format or other decoding errors
    console.error('Error decoding token:', error);
    return true;
  }
};